import { Card, CardContent } from '@/components/ui/card';

export const StatCard = ({ label, value, description }) => {
  return (
    <Card data-testid="impact-stat-card" className="transition-all hover:shadow-lg hover:-translate-y-1 duration-200">
      <CardContent className="p-6">
        <div className="text-center">
          <div className="text-4xl font-bold text-[hsl(var(--primary))]" style={{fontFamily: 'Spectral, serif'}}>
            {typeof value === 'number' ? value.toLocaleString() : value}
          </div>
          <div className="mt-2 text-sm font-semibold text-[hsl(var(--secondary))]">
            {label}
          </div>
          {description && (
            <div className="mt-1 text-xs text-muted-foreground">
              {description}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};